(function () {
  'use strict';
  const source = document.currentScript;
  const state = window.poshaakMarketing;
  if (!source || !state || state.loaderAttached) return;
  state.loaderAttached = true;
  const googleUrl = source.dataset.googleSrc;

  function appendVendor(name, url, existingSelector) {
    if (document.querySelector(existingSelector)) {
      state.vendors[name] = 'existing';
      return;
    }
    const script = document.createElement('script');
    script.async = true;
    script.src = url;
    state.vendors[name] = 'loading';
    script.addEventListener('load', () => { state.vendors[name] = 'loaded'; }, { once: true });
    script.addEventListener('error', () => { state.vendors[name] = 'error'; }, { once: true });
    document.head.appendChild(script);
  }

  function start() {
    if (state.started) return;
    state.started = true;
    state.startedAt = performance.now();
    state.status = 'started';
    document.removeEventListener('visibilitychange', releaseHiddenPage);
    appendVendor('google', googleUrl, 'script[src*="googletagmanager.com/gtag/js"]');
    appendVendor('meta', 'https://connect.facebook.net/en_US/fbevents.js', 'script[src*="connect.facebook.net/"][src*="/fbevents.js"]');
  }

  function releaseHiddenPage() {
    if (document.hidden && state.imageSettledAt !== undefined) start();
  }

  function afterPaint() {
    if (document.hidden || typeof requestAnimationFrame !== 'function') {
      setTimeout(start, 0);
      return;
    }
    document.addEventListener('visibilitychange', releaseHiddenPage);
    requestAnimationFrame(() => requestAnimationFrame(() => setTimeout(start, 0)));
  }

  function watchImage() {
    const image = document.querySelector('#main img[fetchpriority="high"]');
    if (!image) {
      state.reason = 'no-critical-image';
      state.imageSettledAt = performance.now();
      afterPaint();
      return;
    }
    state.status = 'waiting-image';
    let settled = false;
    function settle(reason) {
      if (settled) return;
      settled = true;
      image.removeEventListener('load', onLoad);
      image.removeEventListener('error', onError);
      state.reason = reason;
      state.imageSettledAt = performance.now();
      if (reason === 'image-loaded' && typeof image.decode === 'function') {
        image.decode().catch(() => {}).then(afterPaint);
      } else {
        afterPaint();
      }
    }
    function onLoad() { settle('image-loaded'); }
    function onError() { settle('image-error'); }
    image.addEventListener('load', onLoad, { once: true });
    image.addEventListener('error', onError, { once: true });
    if (image.complete) settle(image.naturalWidth > 0 ? 'image-loaded' : 'image-error');
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watchImage, { once: true });
  else watchImage();
}());
